module.exports = require("core-js/library/fn/array/from");


//////////////////
// WEBPACK FOOTER
// /home/adwant/sites/argus/shared/node_modules/@babel/runtime-corejs2/core-js/array/from.js
// module id = 355
// module chunks = 0